import {useState, useRef} from 'react';
import {DatePicker, Row, Col} from 'antd';
import {toUtcDateStringShort} from "../../util/timeutils";

export const DatePickerWidget = ({date, placeholder, onChange, disabled, children, props}) => {
    const [active, setActive] = useState(false);

    const onClick = () => {
        if (disabled === true) {
            // disabled pickers can not be changed
            return;
        }
        setActive(true);
        // use a timer here to allow time for the DatePicker to mount and allow the ref to become valid
        setTimeout(() => {
            inputRef.current.focus();
        }, 20);
    }

    const inputRef = useRef(null);

    const onDateChange = (date, dateString) => {
        if (onChange) {
            onChange(dateString);
        }
        setActive(false);
    }


    const onBlur = () => {
        setTimeout(() => {
            setActive(false);
        }, 200);
    }

    let dateContent;
    if (date) {
        dateContent = toUtcDateStringShort(new Date(date));
    } else {
        dateContent = `${placeholder}`
    }

    if (active) {
        return <DatePicker placeholder={placeholder} onChange={onDateChange}  onBlur={onBlur} ref={inputRef} />;
    } else {
        return <div style={{cursor: "pointer", color: "#108ee9", marginTop: '5px'}} onClick={onClick}>
            <Row>
                <Col style={{marginRight: '5px'}}>
                    {dateContent}
                </Col>
                <Col>
                    {children}
                </Col>
            </Row>

        </div>
    }
}